import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-52bcc680"), n = n(), _popScopeId(), n); };
var _hoisted_1 = ["r"];
var _hoisted_2 = ["stroke-dasharray"];
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EProgressPie',
    props: {
        progress: { default: 0 },
        type: { default: 'primary' },
        checkedIconClass: {}
    },
    setup: function (__props) {
        var props = __props;
        var dasharray = computed(function () { return (props.progress * 31.4 / 100); });
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            return (_ctx.progress !== 100)
                ? (_openBlock(), _createElementBlock("svg", {
                    key: 0,
                    class: _normalizeClass([[
                            'e-progress-pie--' + _ctx.type,
                        ], "e-progress-pie"]),
                    viewBox: "0 0 20 20"
                }, [
                    _createElementVNode("circle", {
                        r: _ctx.progress === 0 ? 4 : 10,
                        class: "e-progress-pie__bg",
                        cx: "10",
                        cy: "10"
                    }, null, 8, _hoisted_1),
                    _createElementVNode("circle", {
                        "stroke-dasharray": "".concat(dasharray.value, " 31.4"),
                        class: "e-progress-pie__filler",
                        cx: "10",
                        cy: "10",
                        fill: "transparent",
                        r: "5",
                        "stroke-width": "10",
                        transform: "rotate(-90) translate(-20)"
                    }, null, 8, _hoisted_2)
                ], 2))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass([_ctx.checkedIconClass, "flex justify-center items-center bg-primary rounded-full"])
                }, [
                    _createVNode(_component_e_icon, {
                        class: "w-1/2 h-1/2 text-white",
                        icon: "check"
                    })
                ], 2));
        };
    }
});
